import { Component } from '@angular/core';

@Component({
  selector: 'app-pdf-word-content',
  imports: [],
  templateUrl: './pdf-word-content.component.html',
  styleUrl: './pdf-word-content.component.css'
})
export class PdfWordContentComponent {

}
